import { render, staticRenderFns } from "./finish-handle-form.vue?vue&type=template&id=68ad0377&scoped=true"
import script from "./finish-handle-form.vue?vue&type=script&lang=js"
export * from "./finish-handle-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad0377",
  null
  
)

export default component.exports